import React from 'react';
import { Box } from '@styleseat/ui';
import type { ClientProviderProfile } from '../../../../../api/ProfileClientView';

import {
  BodyText,
  HeaderText,
  PortalOverlay,
  PortalOverlayHeader,
  PortalOverlayHeaderCloseBtn,
  PortalOverlayModal,
  Stack,
} from '../../../../ui';
import ReviewListContainer from '../../reviews/ReviewListContainer';
import { useIsMobile } from '../../../../../hooks';

type ReviewsActionModalProps = {
  profile: ClientProviderProfile;
  onClose: () => void;
};

export const ReviewsActionModal: React.FC<ReviewsActionModalProps> = ({
  onClose, profile,
}) => {
  const isMobile = useIsMobile();
  return (
    <PortalOverlay
      name="reviews-action-modal"
      onBackdropClick={onClose}
      overflowScroll={false}
    >
      <PortalOverlayModal
        position="menu"
        borderRadiusTop={isMobile ? 32 : 0}
        boxProps={{
          maxHeight: isMobile ? '100%' : 600,
        }}
      >
        <PortalOverlayHeader
          alignItems="center"
          hideBottomBorder
          renderTitle={() => !isMobile && (<BodyText>Reviews</BodyText>)}
          renderRightAction={() => (
            <Box
              paddingRight={isMobile ? 24 : 16}
              paddingTop={isMobile ? 24 : 0}
            >
              <PortalOverlayHeaderCloseBtn
                noPadding
                onCloseRequest={onClose}
                testID="reviews-action-modal-close-button"
              />
            </Box>
          )}
        />
        <Stack
          flex={1}
          overflowY="scroll"
          overflowX="hidden"
        >
          {isMobile && (
            <Box paddingTop={24} paddingX={24}>
              <HeaderText
                level={1}
                testID="reviews-action-modal-title"
              >
                Reviews
              </HeaderText>
            </Box>
          )}
          <Box
            width="100%"
          >
            <ReviewListContainer
              profile={profile}
            />
          </Box>
        </Stack>
      </PortalOverlayModal>
    </PortalOverlay>
  );
};
